import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { GdFilterBar } from '../../../components/GdFilterBar';
import { useRootStore } from '../../../context/storeContext';

export const GlossaryFilters = observer(() => {
  const { t } = useTranslation();
  const { glossaryStore } = useRootStore();

  const filters = {
    name: {
      span: 12,
      label: t('glossary:Labels:searchLabel'),
      placeholder: t('glossary:Labels:searchPlaceHolder'),
      isSearch: true,
      style: { width: '336px' },
    },
  };

  const onFilter = useCallback(
    (values: any) => {
      glossaryStore.setFilter(values);
    },
    [glossaryStore]
  );

  return <GdFilterBar meta={filters} onFilter={onFilter} />;
});
